module.exports = __webpack_public_path__ + "assets/images/03_0f182db929315098b02e89179dd3b094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/03.png
// module id = 236
// module chunks = 0